const xlsx = require('xlsx');
import ConversationApi from 'dashboard/api/inbox/conversation';
import Vue from 'vue';

const reverseObj = obj => {
  return Object.entries(obj).reduce((acc, [k, v]) => ({ ...acc, [v]: k }), {});
};
const IMPORT_MAPPING_FIELDS = {
  contact_name: {
    required: true,
  },
  contact_number: {
    required: true,
  },
  contact_email: {
    required: false,
  },
  avatar_url: {
    required: false,
  },
  contact_birthday: {
    required: false,
  },
  contact_city: {
    required: false,
  },
  contact_company_name: {
    required: false,
  },
  contact_country: {
    required: false,
  },
  contact_country_code: {
    required: false,
  },
  contact_description: {
    required: false,
  },
  message_type: {
    required: true,
  },
  content: {
    required: true,
  },
  conversation_id: {
    required: true,
  },
  created_at: {
    required: true,
  },
};

export const state = {
  file: null,
  mapping: {},
  statusLoading: false,
  inboxId: null,
  statusInfo: null,
};

export const getters = {
  getAllRows($state) {
    if (!$state.file) return [];
    const workbook = xlsx.read($state.file.thumb, { type: 'binary' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

    return xlsx.utils.sheet_to_json(worksheet, {
      header: 'A',
      range: 0,
      defval: null,
    });
  },
  getParsedRows(_state, { getAllRows }) {
    return getAllRows.slice(1, 11);
  },
  getHeaders(_, { getAllRows }) {
    return getAllRows[0] || {};
  },
  getCustomViewsByFilterType: _state => filterType => {
    return _state.records.filter(record => record.filter_type === filterType);
  },
  mappingFields(_state) {
    return Object.keys(IMPORT_MAPPING_FIELDS);
  },
  requiredFields() {
    return Object.entries(IMPORT_MAPPING_FIELDS)
      .filter(([_k, v]) => v.required)
      .map(([k, _v]) => k);
  },
  unassignedFields($state, { mappingFields, assignedFields }) {
    return mappingFields.filter(value => !assignedFields.includes(value));
  },
  assignedFields($state) {
    return Object.values($state.mapping);
  },
  getMapping($state) {
    return $state.mapping;
  },
  getStatusLoading($state) {
    return $state.statusLoading;
  },
  getIboxId($state) {
    return $state.inboxId;
  },
  getFile($state) {
    return $state.file;
  },
  validMapping({ mapping }) {
    const reversedMapping = reverseObj(mapping);
    return Object.entries(IMPORT_MAPPING_FIELDS).every(([key, value]) => {
      if (value.required) {
        return !!reversedMapping[key];
      }
      return true;
    });
  },
  getStatusInfo($state) {
    return $state.statusInfo;
  },
};

export const actions = {
  async import({ state: $state }) {
    try {
      await ConversationApi.importConversations(
        $state.inboxId,
        $state.file.resource,
        $state.mapping
      );
    } catch (error) {
      console.log(error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error();
      }
    }
  },
  async importStatus({ commit }) {
    try {
      commit('SET_LOADING', true);
      const { data } = await ConversationApi.getImportConversationsStatus();
      commit('SET_STATUS_INFO', data);
    } catch (error) {
      console.log(error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error();
      }
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async importStatusSilent({ commit }) {
    try {
      const { data } = await ConversationApi.getImportConversationsStatus();
      commit('SET_STATUS_INFO', data);
    } catch (error) {
      console.log(error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error();
      }
    }
  },
  async stopImport({ dispatch }) {
    try {
      await ConversationApi.stopImport();
      await dispatch('importStatus');
    } catch (error) {
      console.log(error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error();
      }
    }
  },
};

export const mutations = {
  ['SET_FILE']($state, file) {
    Vue.set($state, 'file', file);
  },
  ['SET_MAPPING']($state, obj) {
    Vue.set($state, 'mapping', { ...$state.mapping, ...obj });
  },
  CLEAR_MAPPING($state) {
    Vue.set($state, 'mapping', {});
  },
  CLEAR_FILE($state) {
    Vue.set($state, 'file', null);
  },
  SET_LOADING($state, value) {
    $state.statusLoading = value;
  },
  SET_INBOX($state, id) {
    $state.inboxId = id;
  },
  SET_STATUS_INFO($state, obj) {
    $state.statusInfo = obj;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
